import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateChurnInfo as UpdateChurnInfoMutation,
    UpdateChurnInfoVariables,
    ChurnInfoUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CHURN_INFO from '../mutations/update-churn-info.graphql';

export const useUpdateChurnInfo = (): {
    updateChurnInfo: (arg1: ChurnInfoUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateChurnInfo, {loading, error}] = useMutation<
        UpdateChurnInfoMutation,
        UpdateChurnInfoVariables
    >(UPDATE_CHURN_INFO);

    return {
        updateChurnInfo: (input: ChurnInfoUpdateInput) =>
            updateChurnInfo({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
